import { FooterService } from '@footer/services/footer.service';
import { CookieService } from 'ngx-cookie-service';
import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Renderer2, Inject } from '@angular/core';
import { BaseComponent } from '@base/component/base.component';
import { Router } from '@angular/router';
import { ProfileService } from '@profile/service/profile.service';
import { ServiceLocator } from '@base/constants/service-locator';
import {
  GetProfileResponse,
  GetUserProfile,
  ChangePassword,
  GetWatchlistData,
  GetfavouriteData,
  AllData,
  ProfileData
} from '@profile/model/profile.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HeaderService } from '@header/services/header.service';
import { PageData } from '@home/model/pagecategory.model';
import { VideoPage } from '@video-page/model/video-page';
import { VideoPageService } from '@video-page/services/videopage.service';
import { AuthService } from 'angularx-social-login';
import * as moment from 'moment';

declare var $: any;
@Component({
  selector: 'app-profile',
  templateUrl: '../view/profile.component.html',
  styleUrls: ['../css/profile.component.css']
})
export class ProfileComponent extends BaseComponent implements OnInit {
  public profileService: ProfileService;
  public profile: ProfileData;
  public pass: any;
  public newpass: any;
  public isLogin: boolean;
  headerService: HeaderService;
  watchlistData: GetWatchlistData;
  favouriteData: GetfavouriteData;
  removeToWatchListData: AllData;
  videopageData: VideoPage;
  public videopageService: VideoPageService;
  removeTofavouriteData: AllData;
  refereshToken: {};
  orderListingData = [];

  public profilePasswordForm: FormGroup = new FormGroup(
    {
      password: new FormControl('', [Validators.required,Validators.pattern(
        '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,15}')]),
      new_password: new FormControl('', [Validators.required,Validators.pattern(
        '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,15}')]),
      confirm_new_password: new FormControl('', [Validators.required,Validators.pattern(
        '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,15}')])
    },
    this.passwordMatchValidator
  );

  public passwordMatchValidator(g: FormGroup) {
    return g.get('new_password').value === g.get('confirm_new_password').value
      ? null
      : { mismatch: true };
  }

  ngOnInit() {
    this.rendrer.removeClass(this.document.body, 'transperent-layout');
    this.rendrer.removeClass(this.document.body, 'hide-header');
    this.rendrer.removeClass(this.document.body, 'hide-footer');
    window.scroll(0, 0);

    $(document).ready(function () {
      $(this).scrollTop(0);
    });

    // $('.tablist ul li a').click(function () {

    //   $('.tablist ul li').removeClass('active');
    //   $(this).parent('li').addClass('active');

    //   const active_div = $(this).attr('dtat-target');
    //   $('.tabing').hide();
    //   $('#' + active_div).show();

    // });

    $('.seasons-list li').click(function () {
      $('.seasons-list li').removeClass('activeSeasons');
      $(this).addClass('activeSeasons');
    });

    this.isLogin = BaseComponent.isLogin;
    // this.isLogin = true;
    this.profileService = ServiceLocator.injector.get(ProfileService);
    this.getfavouritAndWatchlist();
    this.getProfile();
    this.getOrderListing();
  }

  constructor(public router: Router, private authService: AuthService,
              private rendrer: Renderer2,
              @Inject(DOCUMENT) private document: Document,
              private cookieService: CookieService,
              private footerService: FooterService) {
    super();
    this.headerService = ServiceLocator.injector.get(HeaderService);
    this.videopageService = ServiceLocator.injector.get(VideoPageService);
  }

  // public menuClick() {
  //   var active_div = $('li.active');
  //   if (active_div[0].id == 'favoritesa') {
  //     $('#favoritesa').removeClass('active');
  //     $('#paymentId').removeClass('active');
  //     $('#watchlista').addClass('active');
  //     $('#Favorites').css('display', 'none');
  //     $('#Watchlist').css('display', 'block');
  //     $('#Billing-Details').css('display', 'none');

  //   }
  //   if (active_div[0].id == 'watchlista') {
  //     $('#watchlista').removeClass('active');
  //     $('#paymentId').removeClass('active');
  //     $('#favoritesa').addClass('active');
  //     $('#Favorites').css('display', 'block');
  //     $('#Watchlist').css('display', 'none');
  //     $('#Billing-Details').css('display', 'none');

  //   }
  //   if (active_div[0].id == 'paymentId') {
  //     $('#watchlista').removeClass('active');
  //     $('#paymentId').addClass('active');
  //     $('#favoritesa').removeClass('active');
  //     $('#Favorites').css('display', 'none');
  //     $('#Watchlist').css('display', 'none');
  //     $('#Billing-Details').css('display', 'block');
  //   }
  //   // $('.tablist ul li a').click(function () {
  //   //   $('.tablist ul li').removeClass('active');
  //   //   $(this)
  //   //     .parent('li')
  //   //     .addClass('active');

  //   //   var active_div = $(this).attr('dtat-target');
  //   //   $('.tabing').hide();
  //   //   $('#' + active_div).show();
  //   // });

  //   $('.seasons-list li').click(function () {
  //     $('.seasons-list li').removeClass('activeSeasons');
  //     $(this).addClass('activeSeasons');
  //   });
  // }
  public menuClick() {
    $('.tablist ul li a').click(function () {
      $('.tablist ul li').removeClass('active');
      $(this)
        .parent('li')
        .addClass('active');

      var active_div = $(this).attr('dtat-target');
      $('.tabing').hide();
      $('#' + active_div).show();
    });

    $('.seasons-list li').click(function () {
      $('.seasons-list li').removeClass('activeSeasons');
      $(this).addClass('activeSeasons');
    });
  }
  public gotoEditProfile(url): void {
    const myurl = `${url}`;
    this.router.navigateByUrl(myurl);
  }
  public signOut(): void {

    this.headerService.getToken().subscribe(
      res => {
        if (res !== undefined) {
          this.setGuestToken('Bearer ' + res);

          var body = res;
          var base64Url = body.split('.')[1];
          var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          }).join(''));
          this.refereshToken = JSON.parse(jsonPayload);

          var dt = new Date(this.refereshToken['exp'] * 1000);
          BaseComponent.guestTime = moment(dt).subtract(50, 'seconds').format('HH:mm:ss').toString();

          this.headerService.setLogin.emit(false);
          this.footerService.reloadCookies.emit(true);
          this.headerService.reloadHeader.emit(true);
          this.cookieService.delete('readDisclaimer');
          localStorage.removeItem('user');
          localStorage.removeItem('user_token');
          localStorage.removeItem('videoUrl');
          BaseComponent.baseUser = undefined;
          BaseComponent.isLogin = false;
          BaseComponent.userTime = '';
          this.router.navigate(['', 'home']);
        }
      },
      err => {
        console.log(err);
        this.headerService.setLogin.emit(false);
        this.headerService.reloadHeader.emit(true);
        localStorage.removeItem('user');
        localStorage.removeItem('user_token');
        BaseComponent.baseUser = undefined;
        BaseComponent.isLogin = false;
        BaseComponent.userTime = '';
        this.router.navigate(['', 'home']);
      }
    );


  }

  // public removeTofavourite(): void {
  //   const pageRequest = {
  //     user_id: this.getUserId(),
  //     asset_id: this.videopageData.path
  //   };
  //   this.videopageService.removeTofavourite(pageRequest).subscribe(
  //     res => {
  //       if (res !== undefined) {
  //         this.successResponse(res.msg);
  //         this.videopageData.is_favourite = false;
  //       }
  //     },
  //     err => {
  //       console.log(err);
  //     }
  //   );
  // }
  public getProfile(): void {
    const getUserProfile = new GetUserProfile();
    getUserProfile.uid = BaseComponent.user;

    this.profileService.getUserProfile(getUserProfile.uid).subscribe(
      res => {
        if (res !== undefined) {
          BaseComponent.userEmail = res.data[0].emailId;
          BaseComponent.userFName = res.data[0].firstName;
          BaseComponent.userLName = res.data[0].lastName;
          this.profile = res.data[0];
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  public changePassword(profilePasswordForm: FormGroup): void {
    const changepass = new ChangePassword();
    changepass.emailId = BaseComponent.userEmail
    changepass.password = this.profilePasswordForm.value['password'];
    changepass.newPassword = this.profilePasswordForm.value['new_password'];
    if (changepass.password !== changepass.newPassword) {
      this.profileService.createNewPassword(changepass).subscribe(
        res => {
          if (res !== undefined) {
            if (res.success == true) {
              this.successResponse(res.message);
              this.profilePasswordForm.reset();
              $('#changePass').modal('hide');
            } else {
              this.errMessageResponse(res.message);
            }
          }
        },
        err => {
          console.log(err);
        }
      );
    } else {
      this.warningMessageResponse('Old password and new password must be different');
    }

  }

  public getfavouritAndWatchlist(): void {
    const requestWatchlistData = {
      "deviceTypeId": "1"
    };

    // const requestFavouriteData = {
    //   "userId": this.getUserId()
    // };

    let fiterWatchlistString = "?filter="+encodeURI(JSON.stringify(requestWatchlistData));
    // let fiterFavouriteString = "?filter="+encodeURI(JSON.stringify(requestFavouriteData)); 
    this.profileService.getWatchlist(fiterWatchlistString).subscribe(
      res => {
        if (res !== undefined && res.success === true) {
          this.watchlistData = res;
        } else if (res !== undefined && res.success === false) {
        }
      },
      err => {
        console.log(err);
      }
    );

    this.profileService.getfavourite().subscribe(
      res => {
        if (res !== undefined && res.success === true) {
          this.favouriteData = res.data;
          console.log('favouriteData', this.favouriteData);
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  getOrderListing() {
    // const orderListingData = {
    //   "userId": this.getUserId()
    // };

    // let fiterWatchlistString = "?filter="+encodeURI(JSON.stringify(orderListingData));
    
    this.profileService.getOrderListing().subscribe(
      res => {
        if(res != undefined && res.success == true) {
          this.orderListingData = res.data.data
        }
    })
  }

  public gotoVideoPage(pagedata: PageData): void {
    if (pagedata.assetType.toLowerCase()  === 'asset' && pagedata.asset_group_id == null) {
      this.router.navigate(['/video', pagedata.title.split(/\s/).join(''), pagedata.path]);
    } else if (pagedata.assetType.toLowerCase() === 'asset_group') {
      this.router.navigate(['/season', pagedata.path]);
    } else if (pagedata.asset_group_id != null && pagedata.asset_group_id > 0) {
      localStorage.setItem('favouriteUrl', pagedata.path);
      localStorage.setItem('favouriteUrlCat', pagedata.asset_category_id);
      this.router.navigate(['/season', pagedata.asset_group_id]);
    }
  }
  public gotoVideoPagefromWatchList(pagedata: PageData): void {
    console.log("pagedata==>",pagedata);
    if (pagedata.assetType.toLowerCase() == 'asset' && pagedata.asset_group_id == null) {
      this.router.navigate(['/video', pagedata.title.split(/\s/).join(''), pagedata.path]);
    } else if (pagedata.assetType.toLowerCase() === 'asset_group') {
      this.router.navigate(['/season', pagedata.path]);
    } else if (pagedata.asset_group_id != null && pagedata.asset_group_id > 0) {
      localStorage.setItem('watchListUrl', pagedata.path);
      localStorage.setItem('watchListUrlCat', pagedata.asset_category_id);
      this.router.navigate(['/season', pagedata.asset_group_id]);
    }
  }

  public downloadInvoice (invoice) {
    const invoiceRequest = {
      invoiceId: invoice.orderId
    };
    let fiterString = "?filter=" + encodeURI(JSON.stringify(invoiceRequest));
    this.profileService.downloadInvoice(fiterString).subscribe(
      res => {
        if (res !== undefined && res.success == true) {
          console.log(res);
          // pdf download start
          const linkSource = 'data:application/pdf;base64,' + res.data;
          const downloadLink = document.createElement("a");
          const fileName = "sample.pdf";

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          // pdf download end
          // imageConvert start
          // var a = document.createElement("a"); //Create <a>
          // a.href = "data:image/png;base64," + res.data; //Image Base64 Goes here
          // a.download = "Image.png"; //File name Here
          // a.click(); 
          // imageConvert end
        }
      })
  }

  public removeTofavourite(assetItem: AllData): void {
    let index: any;
    const pageRequest = {
      assetId: assetItem.path
    };
    this.videopageService.removeTofavourite(pageRequest).subscribe(
      res => {
        if (res !== undefined) {
          this.successResponse(res.message);
          index = this.favouriteData.data.indexOf(assetItem);
          this.favouriteData.data.splice(index, 1);
        }
      },
      err => {
        console.log(err);
      }
    );
  }


  public setremoveTofavouriteData(setdata: AllData): void {
    this.removeTofavouriteData = setdata;
  }


  public removeToWatchList(assetItem: AllData): void {
    
    let index: any;
    
    const pageRequest = {
      assetId: assetItem.path,
      userId: this.getUserId(),
      // profileId:this.profile.id
    };
    this.videopageService.removeToWatchList(pageRequest).subscribe(
      res => {
        console.log("this.watchlistData");
        console.log(this.watchlistData.data);
        if (res !== undefined) {
         // debugger;
          this.successResponse(res.message);
          index = this.watchlistData.data.indexOf(assetItem);
          this.watchlistData.data.splice(index, 1);
        }
      },
      err => {
        console.log(err);
      }
    );
  }


  public setremoveToWatchListData(setdata: AllData): void {
    this.removeToWatchListData = setdata;
  }
  closeModel(){
   this. profilePasswordForm.reset();
   $('#changePass').modal('hide');

  }
}
